"use client";
import Image, { StaticImageData } from "next/image";
import DOMPurify from "isomorphic-dompurify";
type BlogHeroProps = {
  title: string;
  category: string;
  date: any;
  imageSrc: string | StaticImageData;
};

export default function BlogHero({
  title,
  category,
  date,
  imageSrc,
}: BlogHeroProps) {
  return (
    <div className="flex flex-col gap-4 md:gap-5">
      <h1
        className="self-stretch justify-start text-[22px] lg:text-[length:var(--section-title)] font-medium clash-font leading-[120%] mt-8 lg:mt-0"
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(title) }}
      />

      <div className="flex items-center gap-3 md:gap-4">
        <span className="inline-flex items-center justify-center rounded-[45px] bg-[#ECF0F6] px-4 md:px-5 py-1.5 md:py-2 text-[14px] md:text-[16px] font-medium text-[#00040b]">
          {category}
        </span>
        <div className="flex items-center gap-3">
          <span className="text-[16px]  md:text-[18px] text-[#636364] font-medium">
            Published On: {date?.publishedDate}
          </span>
          <span className="text-[16px] px-10 md:text-[18px] text-[#636364] font-medium">
            Last Updated: {date?.date}
          </span>
        </div>
      </div>
      <div className="relative w-full h-auto overflow-hidden rounded">
        <Image
          src={imageSrc}
          alt={title}
          width={1000}
          height={1000}
          priority
          fetchPriority="high"
          className="w-full h-auto"
        />
      </div>
    </div>
  );
}
